<template>
    <b-modal
        id="ConfirmationModal"
        v-model="shown"
        centered
        :title="title"
        lazy
    >
        <Spinner v-if="loading" />
        <b-container
            v-else
            fluid
        >
            <b-row>
                {{ body }}
            </b-row>
        </b-container>
        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="handleClose()"
            >
                Close
            </b-btn>
            <Button
                :variant="submitButtonVariant"
                :disabled="loading"
                :loading="submitLoading"
                @click="handleSubmit()"
            >
                Confirm
            </Button>
        </div>
    </b-modal>
</template>

<script>
export default {

    data() {
        return {
            shown: false,
            loading: false,
            submitLoading: false,
            title: null,
            body: null,
            onSubmit: null,
            submitButtonVariant: null,
        };
    },

    watch: {
        shown(shown) {
            if (shown) {
                this.reset();
            }
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openConfirmationModal, ({ title, body, onSubmit, submitButtonVariant }) => {
            this.title = title;
            this.body = body;
            this.onSubmit = onSubmit;
            this.submitButtonVariant = submitButtonVariant || 'success';
            this.shown = true;
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            await this.onSubmit();
            this.submitLoading = false;
            this.handleClose();
        },
        handleClose() {
            this.shown = false;
        },
        reset() {
            this.loading = false;
            this.submitLoading = false;
        },
    },

};
</script>
